import { render } from "./NewSmallEntry.vue?vue&type=template&id=c7fcd00e&scoped=true"
import script from "./NewSmallEntry.vue?vue&type=script&lang=js"
export * from "./NewSmallEntry.vue?vue&type=script&lang=js"

import "./NewSmallEntry.vue?vue&type=style&index=0&id=c7fcd00e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c7fcd00e"

export default script